import React, { useState } from 'react'
import { DocumentNew, DocumentsNew } from 'domain/entities/document'
import SupportTextNew from 'presentation/shared/components/SupportTextNew'
import AccordionCard from 'presentation/shared/components/AccordionCard'
import ValidateDocumentForm from 'presentation/hospital/components/Forms/ValidateDocumentForm'
import * as S from './styles'
import { DocumentStatusEnum } from 'common/enum/document-status'
import moment from 'moment-timezone'

export type Props = {
  title?: string
  documents: DocumentsNew[]
  surgicalPendencyId?: number
  surgicalOrderId?: number
  refreshDocuments?: any
  topButton?: React.ReactNode
}

type CardHeaderProps = {
  document: DocumentsNew
}

type CardContentProps = {
  documents: DocumentNew[]
  surgicalPendencyId?: number
  surgicalOrderId?: number
  refreshDocuments?: (surgicalPendencyId: number) => void
}

const DocumentsAttached = ({
  title,
  documents,
  surgicalPendencyId,
  surgicalOrderId,
  refreshDocuments,
  topButton
}: Props) => {
  const [currentOpenAccordionLabel, setCurrentOpenAccordionLabel] = useState<
    string | false
  >(false)

  const handleChange = (accordionLabel: string, isExpanded: boolean) =>
    setCurrentOpenAccordionLabel(isExpanded ? accordionLabel : false)

  return (
    <S.Wrapper>
      {topButton}
      {title && (
        <SupportTextNew
          color="neutral900"
          size="medium"
          weight="bold"
          style={{ marginBottom: '24px' }}
          as="h6"
        >
          {title}
        </SupportTextNew>
      )}
      <S.CardsWrapper>
        {documents?.length > 0 ? (
          documents.map((document, index) => (
            <AccordionCard
              key={index}
              accordionLabel={`doc-${index}`}
              expanded={currentOpenAccordionLabel === `doc-${index}`}
              handleChange={handleChange}
              header={<CardHeader document={document} />}
              content={
                <CardContent
                  documents={document.documents}
                  surgicalPendencyId={surgicalPendencyId}
                  surgicalOrderId={surgicalOrderId}
                  refreshDocuments={refreshDocuments}
                />
              }
            />
          ))
        ) : (
          <SupportTextNew color="neutral700">
            Nenhum documento foi anexado até o momento.
          </SupportTextNew>
        )}
      </S.CardsWrapper>
    </S.Wrapper>
  )
}

export default DocumentsAttached

const CardHeader = ({ document }: CardHeaderProps) => {
  return (
    <S.CardHeader>
      <SupportTextNew weight="semiBold" color="neutral800">
        {document.type}
      </SupportTextNew>
      <SupportTextNew size="xxsmall" color="neutral500" lineHeight="small">
        {document.status === DocumentStatusEnum.ANALYZING
          ? 'Pendente de validação'
          : document.status === DocumentStatusEnum.APPROVED
          ? `Validado em ${moment(document.status_updated_at).format(
              'DD MMM YYYY'
            )} por ${document.status_updated_by?.name}`
          : `Invalidado em ${moment(document.status_updated_at).format(
              'DD MMM YYYY'
            )} por ${document.status_updated_by?.name}`}
      </SupportTextNew>
    </S.CardHeader>
  )
}

const CardContent = ({
  documents,
  surgicalPendencyId,
  surgicalOrderId,
  refreshDocuments
}: CardContentProps) => {
  return (
    <S.CardContent>
      {documents.map((document, index) => (
        <div key={index}>
          <ValidateDocumentForm
            document={document}
            multipleDocuments={documents.length > 1}
            documentIndex={index}
            surgicalPendencyId={surgicalPendencyId}
            surgicalOrderId={surgicalOrderId}
            refreshDocuments={refreshDocuments}
          />
        </div>
      ))}
    </S.CardContent>
  )
}
